"use client"

import { useState } from "react"
import { API_BASE_URL } from "../../config"

const AdminProductCard = ({ product, onEdit, onDelete }) => {
  const [imageLoaded, setImageLoaded] = useState(false)

  const { item_data = {} } = product
  const name = item_data.name || "Unnamed Product"
  const description = item_data.description_plaintext || item_data.description || ""
  const variations = item_data.variations || []
  const imageId = item_data.image_ids?.[0]
  const image = imageId ? `${API_BASE_URL}/api/image/${imageId}` : "/placeholder.svg?height=200&width=200"

  // Get price from first variation
  const firstVariation = variations[0]
  const price = firstVariation?.item_variation_data?.price_money?.amount
    ? (firstVariation.item_variation_data.price_money.amount / 100).toFixed(2)
    : "0.00"

  return (
    <div className="bg-white rounded-lg shadow-md overflow-hidden hover:shadow-lg transition-shadow flex flex-col h-full">
      {/* Image */}
      <div className="aspect-square bg-gray-200 relative">
        {!imageLoaded && <div className="absolute inset-0 bg-gray-300 animate-pulse"></div>}
        <img
          src={image || "/placeholder.svg"}
          alt={name}
          className={`w-full h-full object-cover transition-opacity duration-300 ${
            imageLoaded ? "opacity-100" : "opacity-0"
          }`}
          onLoad={() => setImageLoaded(true)}
          onError={() => setImageLoaded(true)}
        />
      </div>

      {/* Content - flex-grow to push buttons to bottom */}
      <div className="p-4 flex flex-col flex-grow">
        <h3 className="font-semibold text-lg text-gray-900 mb-2 line-clamp-2">{name}</h3>

        <p className="text-gray-600 text-sm mb-3 line-clamp-2 flex-grow">{description}</p>

        <div className="flex items-center justify-between mb-4">
          <span className="text-xl font-bold text-gray-900">${price}</span>
          {variations.length > 1 && <span className="text-sm text-gray-500">{variations.length} variants</span>}
        </div>

        {/* Action Buttons - always at bottom */}
        <div className="flex space-x-2 mt-auto">
          <button
            onClick={onEdit}
            className="flex-1 bg-blue-600 hover:bg-blue-700 text-white py-2 px-3 rounded text-sm font-medium transition-colors"
          >
            Edit
          </button>
          <button
            onClick={onDelete}
            className="flex-1 bg-red-600 hover:bg-red-700 text-white py-2 px-3 rounded text-sm font-medium transition-colors"
          >
            Delete
          </button>
        </div>
      </div>
    </div>
  )
}

export default AdminProductCard
